const {
  isTestServer,
  testUrl,
  baseUrl,
  enableAzureBackupForStorage,
  backUpStorageData,
  productionStorageData,
  enableAzureSpeechKey,
  backUpAzureSpeechKey,
  productionAzureSpeechKey,
  enableBackUpAzureSpeechKey,
} = require("../api/api_urls");
const nebulla = require("../assests/ai_avatars/nebulla.png");
const Zenith = require("../assests/ai_avatars/Zenith.png");
const Lucy = require("../assests/ai_avatars/Lucy.png");
const Jarvis = require("../assests/ai_avatars/Jarvis.png");
const sithara = require("../assests/ai_avatars/sithara.png");
const Ishaan = require("../assests/ai_avatars/Ishaan.png");
const Lumina = require("../assests/ai_avatars/Lumina.png");
const raayan = require("../assests/ai_avatars/raayan.png");

module.exports = Object.freeze({
  apiLink: isTestServer ? testUrl : baseUrl,
  // enableAzureBackupForStorage: true,
  interviewCompletedSequence: [
    "Interview done successfully.",
    "Interview done successfully",
    "interview is done successfully.",
    "interview is done successfully",
    "interview is over now.",
    "interview is over now",
    "interview is completed.",
    "interview is completed",
    "interview is done.",
    "interview is done",
    "interview is finished.",
    "interview is finished",
    "interview is completed now.",
    "interview is completed now",
    "interview is finished now.",
    "interview is finished now",
    "interview is over.",
    "interview is over",
    "interview is completed successfully.",
    "interview is completed successfully",
    "interview is finished successfully.",
    "interview is finished successfully",
    "completed the interview.",
    "completed the interview",
    "Interview done successfully!",
    "Interview done successfully!.",
    "interview has been completed successfully.",
    "interview has been completed successfully",
    "interviewDoneSuccessfully",
    "interviewDoneSuccessfully.",
    "interviewDoneSuccessfully",
    "interview is now completed",
    "interview is now completed.",
    "interview is now finished",
    "interview is now finished.",
    "interview completed",
    "interview completed.",
    "interview is now done successfully",
    "interview is now done successfully.",
    "Interview successfully completed.",
    "Interview successfully finished.",
    "Successfully completed the interview.",
    "Successfully finished the interview.",
    "Interview wrapped up.",
    "Interview is wrapped up.",
    "Interview has concluded.",
    "Interview concluded.",
    "Interview is now over.",
    "Interview session is completed.",
    "Interview session is done.",
    "Interview process completed.",
    "Interview process done.",
    "Interview ended successfully.",
    "Successfully done with the interview.",
    "The interview is officially over.",
    "Interview is now officially completed.",
    "Interview phase completed.",
    "Interview phase over.",
    "Interview completed without issues.",
    "Interview ended on a good note.",
    "Wrapped up the interview successfully.",
    "Interview officially concluded.",
    "Interview is all done.",
    "Just finished the interview.",
    "The interview is over and done.",
    "The interview is done and dusted.",
    "interviewDoneSuccessfully",
    "InterviewDoneSuccessfully",
    "interviewDoneSuccessfully!",
    "interviewDoneSuccessfully_",
    "InterviewDoneSuccessfully_",
    "interviewDoneSuccessfully123",
    "InterviewDoneSuccessfully2024",
    "#interviewDoneSuccessfully",
    "#InterviewDoneSuccessfully",
    "#interviewDoneSuccessfully!",
    "#interviewDoneSuccessfully_",
    "#InterviewDoneSuccessfully_",
    "#interviewDoneSuccessfully123",
    "#InterviewDoneSuccessfully2024",
  ],
  teamRoles: [
    //     adminId : 65f96a011dec42fd7d6cc0f9
    // maintainerId  : 65f96af61dec42fd7d6cc18a
    // viewerid  : 65fbc9107466389f144373d8
    {
      role: "Admin",
      id: "65f96a011dec42fd7d6cc0f9",
    },
    {
      role: "Maintainer",
      id: "65f96af61dec42fd7d6cc18a",
    },
    {
      role: "Viewer",
      id: "6971bb50ce17d9413a277db4",
    },
  ],
  roles: [
    {
      role: "student",
      id: "647ce2e8c41bee677ea39fc4",
      description: "student",
    },
    {
      role: "company",
      id: "6551bda478cf4fd1e4316dc9",
      description: "company",
    },
  ],

  // Comprehensive skill options in alphabetical order
  SKILL_OPTIONS: [
    "A/B Testing",
    "Accessibility Testing",
    "Actix",
    "Adobe XD",
    "Agile",
    "Airflow",
    "Alpine.js",
    "Amplitude",
    "Android Development",
    "Android SDK",
    "Android Studio",
    "Angular",
    "Ansible",
    "Ant Design",
    "API Gateway",
    "Apollo",
    "Appium",
    "ArangoDB",
    "ArgoCD",
    "ASP.NET",
    "ASP.NET Core",
    "Assembly",
    "Axum",
    "Azure",
    "Babel",
    "Backbone.js",
    "Behavior-Driven Development",
    "Big Data",
    "Bitbucket",
    "Blazor",
    "Blue-Green Deployment",
    "Bootstrap",
    "Business Analysis",
    "Business Development",
    "C#",
    "C++",
    "Canvas API",
    "Canary Deployment",
    "Cassandra",
    "CDN",
    "Chai",
    "Chakra UI",
    "Chef",
    "CircleCI",
    "CI/CD",
    "Clean Architecture",
    "Clojure",
    "CloudFormation",
    "COBOL",
    "Code Coverage",
    "Code Review",
    "CodeIgniter",
    "Collaboration",
    "Communication",
    "Component Libraries",
    "Conflict Resolution",
    "Continuous Delivery",
    "Continuous Deployment",
    "Continuous Integration",
    "Conversion Optimization",
    "Cordova",
    "Corporate Social Responsibility",
    "CQRS",
    "Creativity",
    "Critical Thinking",
    "Cross-platform Development",
    "CSS",
    "Cultural Awareness",
    "Customer Success",
    "Cypress",
    "Dart",
    "Data Analysis",
    "Data Science",
    "Datadog",
    "dbt",
    "Deep Learning",
    "Design Patterns",
    "Design Systems",
    "Detox",
    "DevOps",
    "Digital Marketing",
    "DigitalOcean",
    "Discord",
    "Diversity & Inclusion",
    "Django",
    "Docker",
    "Docker Compose",
    "Documentation",
    "Domain-Driven Design",
    "Docusaurus",
    "DynamoDB",
    "Echo",
    "Edge Computing",
    "Elasticsearch",
    "Elixir",
    "Email Marketing",
    "Ember.js",
    "Emotional Intelligence",
    "Empathy",
    "End-to-End Testing",
    "ESLint",
    "Ethics",
    "Event Sourcing",
    "Event-Driven Architecture",
    "Express.js",
    "F#",
    "FastAPI",
    "Fastify",
    "Feature Flags",
    "Fiber",
    "Figma",
    "Firebase",
    "Flask",
    "Flutter",
    "Flux",
    "Fortran",
    "Framer Motion",
    "Full Stack Development",
    "Functions",
    "Gatsby",
    "Git",
    "GitHub",
    "GitHub Actions",
    "GitLab",
    "GitLab CI",
    "Gin",
    "Go",
    "Google Analytics",
    "Google Cloud",
    "Google Meet",
    "Grafana",
    "GraphQL",
    "gRPC",
    "Hadoop",
    "Haskell",
    "Headless UI",
    "Helm",
    "Heroku",
    "Hexagonal Architecture",
    "Hotjar",
    "HTML",
    "Husky",
    "Hybrid App Development",
    "Information Architecture",
    "InfluxDB",
    "Innovation",
    "Insomnia",
    "Integration Testing",
    "InVision",
    "Ionic",
    "iOS Development",
    "JAMstack",
    "Java",
    "JavaScript",
    "Jasmine",
    "Jest",
    "Jetpack Compose",
    "Jupyter",
    "Kanban",
    "Karma",
    "Kafka",
    "Koa",
    "Kotlin",
    "Kubernetes",
    "Kysely",
    "LAMP Stack",
    "Laravel",
    "Lambda",
    "Leadership",
    "Lean",
    "Less",
    "Lint-staged",
    "Load Balancing",
    "Load Testing",
    "Machine Learning",
    "Mantine",
    "Material-UI",
    "MATLAB",
    "MEAN Stack",
    "MEVN Stack",
    "MERN Stack",
    "Microservices",
    "Microservices Architecture",
    "Microsoft Teams",
    "Mixpanel",
    "Mobile App Development",
    "Mob Programming",
    "Mocha",
    "MongoDB",
    "Mongoose",
    "Monolithic Architecture",
    "MySQL",
    "NativeScript",
    "Neo4j",
    "Neon",
    "NestJS",
    "Netlify",
    "New Relic",
    "Next.js",
    "Node.js",
    "Notion",
    "Nuxt.js",
    "NumPy",
    "Objective-C",
    "Oracle",
    "Pair Programming",
    "Pandas",
    "Parcel",
    "Performance Testing",
    "Perl",
    "PhoneGap",
    "Phoenix",
    "PlanetScale",
    "Playwright",
    "PostgreSQL",
    "Postman",
    "Presentation Skills",
    "Prettier",
    "Prisma",
    "Problem Solving",
    "Product Management",
    "Progressive Web Apps",
    "Project Management",
    "Prometheus",
    "Protractor",
    "Prototyping",
    "Public Speaking",
    "Pulumi",
    "Puppet",
    "Puppeteer",
    "PyTorch",
    "Python",
    "R",
    "Radix UI",
    "Railway",
    "React",
    "React Native",
    "Redis",
    "Remix",
    "Render",
    "Requirements Gathering",
    "REST API",
    "Risk Management",
    "Rocket",
    "Rollup",
    "Ruby",
    "Ruby on Rails",
    "Rust",
    "SASS",
    "Sales",
    "Scala",
    "Scikit-learn",
    "Scrum",
    "SCSS",
    "Security Testing",
    "Selenium",
    "Semantic Release",
    "Sequelize",
    "Serverless",
    "Serverless Architecture",
    "Service Workers",
    "Sketch",
    "Sinatra",
    "Sinon",
    "Slack",
    "SOLID Principles",
    "Solid.js",
    "Solr",
    "SonarQube",
    "Spark",
    "Spring Boot",
    "Spring MVC",
    "SQL Server",
    "SQLite",
    "Stakeholder Management",
    "Storybook",
    "Strategic Planning",
    "Stylus",
    "Supabase",
    "Sustainability",
    "SVN",
    "Swift",
    "SwiftUI",
    "Symfony",
    "Svelte",
    "Tailwind CSS",
    "Team Management",
    "Technical Writing",
    "TensorFlow",
    "Terraform",
    "Test-Driven Development",
    "Testing Library",
    "Three.js",
    "Thunder Client",
    "Time Management",
    "Travis CI",
    "TypeORM",
    "TypeScript",
    "TypeScript Compiler",
    "UIKit",
    "Unit Testing",
    "User Experience Design",
    "User Interface Design",
    "User Research",
    "Usability Testing",
    "Vercel",
    "Vite",
    "VitePress",
    "Vitest",
    "Vue.js",
    "Web Workers",
    "WebAssembly",
    "WebGL",
    "Webpack",
    "Wireframing",
    "Xamarin",
    "Xcode",
    "Zeplin",
    "Zoom",
    // Non-technical additions
    "Public Relations",
    "Community Management",
    "Customer Support",
    "Account Management",
    "Lead Generation",
    "Inside Sales",
    "Field Sales",
    "B2B Sales",
    "B2C Sales",
    "Event Management",
    "Operations Management",
    "Office Administration",
    "Microsoft Excel",
    "Google Sheets",
    "Microsoft PowerPoint",
    "Microsoft Word",
    "Business Writing",
    "Proposal Writing",
    "RFP & Tendering",
    "Procurement",
    "Supply Chain",
    "Talent Acquisition",
    "Recruitment",
    "Interviewing",
    "Onboarding",
    "HR Operations",
    "Payroll",
    "Training & Development",
    "Instructional Design",
    "Teaching",
    "Counseling",
    "Canva",
    "Brand Management",
    "Community Outreach",
  ],

  // Comprehensive qualification options in alphabetical order
  QUALIFICATION_OPTIONS: [
    // Academic - Secondary
    "10th Pass",
    "12th Pass",
    // Diplomas & Associate
    "Diploma in Computer Science",
    "Diploma in Information Technology",
    "Diploma in Electronics",
    "Diploma in Electrical",
    "Diploma in Mechanical",
    "Diploma in Civil",
    "Diploma in Chemical",
    "Diploma in Biomedical",
    "Associate Degree",
    // Bachelor's
    "B.Tech",
    "B.E.",
    "B.Sc (Computer Science)",
    "B.Sc (Information Technology)",
    "B.Sc (Electronics)",
    "B.Sc (Mathematics)",
    "B.Sc (Physics)",
    "B.Sc (Chemistry)",
    "B.Sc (Statistics)",
    "BCA",
    "BBA",
    "B.Com",
    "BA",
    "B.Des",
    "B.Arch",
    "B.Pharm",
    "B.Sc Nursing",
    "LLB",
    "MBBS",
    "BDS",
    // Master's
    "M.Tech",
    "M.E.",
    "M.Sc (Computer Science)",
    "M.Sc (Information Technology)",
    "M.Sc (Data Science)",
    "M.Sc (Artificial Intelligence)",
    "M.Sc (Mathematics)",
    "M.Sc (Statistics)",
    "M.Sc (Physics)",
    "M.Sc (Chemistry)",
    "MS",
    "MCA",
    "MBA",
    "M.Com",
    "MA",
    "M.Pharm",
    "MHA",
    "LLM",
    // Doctorate
    "PhD (Computer Science)",
    "PhD (Engineering)",
    "PhD (Data Science)",
    "PhD (Mathematics)",
    "PhD (Management)",
    // Professional Certifications
    "CA (Chartered Accountant)",
    "CS (Company Secretary)",
    "CMA (Cost & Management Accountant)",
    "CFA",
    "CPA",
    "ACCA",
    // Project/Product/Process
    "PMP",
    "PRINCE2 Foundation",
    "PRINCE2 Practitioner",
    "CSM (Scrum Master)",
    "PSM (Professional Scrum Master)",
    "Six Sigma Green Belt",
    "Six Sigma Black Belt",
    "ITIL Foundation",
    // Cloud & DevOps
    "AWS Certified Cloud Practitioner",
    "AWS Certified Solutions Architect – Associate",
    "AWS Certified Solutions Architect – Professional",
    "AWS Certified Developer – Associate",
    "AWS Certified DevOps Engineer – Professional",
    "Microsoft Azure Fundamentals (AZ-900)",
    "Microsoft Azure Administrator (AZ-104)",
    "Microsoft Azure Solutions Architect (AZ-305)",
    "Google Cloud Digital Leader",
    "Google Professional Cloud Architect",
    "Kubernetes (CKA)",
    "Kubernetes (CKAD)",
    "Docker Certified Associate",
    // Data / Analytics
    "Tableau Desktop Specialist",
    "Power BI Data Analyst Associate",
    "Snowflake SnowPro Core",
    "Databricks Lakehouse Fundamentals",
    // Security & Systems
    "Cisco CCNA",
    "Cisco CCNP",
    "CompTIA Security+",
    "Certified Ethical Hacker (CEH)",
    "Red Hat RHCSA",
    "Red Hat RHCE",
    // Platforms & Enterprise
    "Salesforce Administrator",
    "Salesforce Platform Developer I",
    "SAP Certified Associate",
    "Oracle Certified Professional",
    // Design/Marketing
    "Google UX Design Certificate",
    "Meta Digital Marketing Associate",
    // Miscellaneous Diplomas / Certificates
    "Diploma in Web Development",
    "Diploma in Data Science",
    "Diploma in AI/ML",
    "Diploma in Cloud Computing",
    "Diploma in Cybersecurity",
    "Diploma in DevOps",
    "Diploma in UI/UX",
    "Certificate in Product Management",
    "Certificate in Business Analytics",
    "Certificate in Financial Modeling",
  ],

  // Predefined city options
  CITY_OPTIONS: [
    "Adityapur",
    "Agartala",
    "Agra",
    "Ahmedabad",
    "Ahmednagar",
    "Aizawl",
    "Ajmer",
    "Akola",
    "Aligarh",
    "Alwar",
    "Ambattur",
    "Amravati",
    "Amritsar",
    "Asansol",
    "Aurangabad",
    "Avadi",
    "Bally",
    "Ballari",
    "Bareilly",
    "Bardhaman",
    "Bathinda",
    "Belagavi",
    "Bengaluru",
    "Bhagalpur",
    "Bhavnagar",
    "Bhilai",
    "Bhilwara",
    "Bhopal",
    "Bhubaneswar",
    "Bidhan Nagar",
    "Bijapur",
    "Bilaspur",
    "Bikaner",
    "Bokaro Steel City",
    "Brahmapur",
    "Chandigarh",
    "Chandrapur",
    "Chennai",
    "Coimbatore",
    "Cuttack",
    "Daman",
    "Darbhanga",
    "Davanagere",
    "Dehradun",
    "Delhi",
    "Dewas",
    "Dhanbad",
    "Dhule",
    "Dispur",
    "Etawah",
    "Faridabad",
    "Gandhinagar",
    "Gangtok",
    "Gaya",
    "Ghaziabad",
    "Gorakhpur",
    "Gulbarga",
    "Guntur",
    "Guwahati",
    "Gwalior",
    "Hajipur",
    "Hisar",
    "Hosur",
    "Howrah",
    "Hubli-Dharwad",
    "Hyderabad",
    "Ichalkaranji",
    "Imphal",
    "Indore",
    "Itanagar",
    "Jabalpur",
    "Jaipur",
    "Jalandhar",
    "Jalgaon",
    "Jamnagar",
    "Jamshedpur",
    "Jhansi",
    "Jodhpur",
    "Junagadh",
    "Kadapa",
    "Kakinada",
    "Kalyan-Dombivali",
    "Kamarhati",
    "Kanpur",
    "Karnal",
    "Kavaratti",
    "Kochi",
    "Kohima",
    "Kolkata",
    "Kolhapur",
    "Kollam",
    "Korba",
    "Kota",
    "Kozhikode",
    "Kulti",
    "Kurnool",
    "Latur",
    "Loni",
    "Lucknow",
    "Ludhiana",
    "Madurai",
    "Maheshtala",
    "Mangalore",
    "Mathura",
    "Meerut",
    "Moradabad",
    "Mumbai",
    "Muzaffarpur",
    "Mysuru",
    "Nadiad",
    "Nagpur",
    "Nanded",
    "Nashik",
    "Navi Mumbai",
    "Nellore",
    "Nizamabad",
    "Ozhukarai",
    "Pallavaram",
    "Panaji",
    "Panipat",
    "Parbhani",
    "Patna",
    "Pendik",
    "Phusro",
    "Pimpri-Chinchwad",
    "Ponnani",
    "Port Blair",
    "Prayagraj",
    "Pune",
    "Raipur",
    "Rajahmundry",
    "Rajkot",
    "Rampur",
    "Ranchi",
    "Ratlam",
    "Rohtak",
    "Roorkee",
    "Saharanpur",
    "Salem",
    "Sambhal",
    "Sangli-Miraj",
    "Satara",
    "Saugor",
    "Shahjahanpur",
    "Shillong",
    "Shivamogga",
    "Shivpuri",
    "Siliguri",
    "Silvassa",
    "Singrauli",
    "Solapur",
    "Srinagar",
    "Surat",
    "Thane",
    "Thiruvananthapuram",
    "Thrissur",
    "Tiruchirappalli",
    "Tirunelveli",
    "Tirupati",
    "Tiruppur",
    "Tumkur",
    "Udaipur",
    "Ulhasnagar",
    "Uluberia",
    "Vadodara",
    "Varanasi",
    "Vasai-Virar",
    "Vijayawada",
    "Visakhapatnam",
    "Vizianagaram",
    "Warangal",
    "Yamunanagar",
  ],

  audioOptions: [
    {
      id: 1,
      country: "UK",
      gender: "Female",
      label: "Nebulla",
      voice: "en-GB-SoniaNeural",
      image: nebulla,
    },
    {
      id: 2,
      country: "UK",
      gender: "Male",
      label: "Zenith",
      voice: "en-GB-RyanNeural",
      image: Zenith,
    },
    {
      id: 3,
      country: "US",
      gender: "Female",
      label: "Lucy",
      voice: "en-US-ElizabethNeural",
      image: Lucy,
    },
    {
      id: 4,
      country: "US",
      gender: "Male",
      label: "Jarvis",
      voice: "en-US-EricNeural",
      image: Jarvis,
    },
    {
      id: 5,
      country: "India",
      gender: "Female",
      label: "Sithara",
      voice: "en-IN-NeerjaNeural",
      image: sithara,
    },
    {
      id: 6,
      country: "India",
      gender: "Male",
      label: "Ishaan",
      voice: "en-IN-PrabhatNeural",
      image: Ishaan,
    },
    {
      id: 7,
      country: "Middle East",
      gender: "Female",
      label: "Lumina",
      voice: "ar-SA-ZariyahNeural",
      image: Lumina,
    },
    {
      id: 8,
      country: "Middle East",
      gender: "Male",
      label: "Raayan",
      voice: "en-AU-TimNeural",
      image: raayan,
    },
  ],
  interviewsList: [
    {
      interviewId: 1,
      title: "Basic Mock Practice",
      id: 1, // interview id
      model: 1, // ai model id
      description:
        "Efficient for Foundation Building: Basic mock practice efficiently [ Efficiency 60% ] establishes a foundational understanding, aiding in confidence-building and initial self-assessment.",
    },
    {
      title: "Technical Mock Interview",
      id: 2,
      interviewId: 2,
      // model: 3,
      model: 1, // ai model id
      description:
        "Efficient Initial Screening: A resume interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    },
    {
      title: "Company Specific Interview",
      id: 3,
      interviewId: 3,
      // model: 3,
      model: 1, // ai model id
      description:
        "Effective Candidate Evaluation: The company interview efficiently evaluates candidates through various formats, offering a comprehensive assessment of skills and cultural fit for the organization.",
    },
    {
      title: "Company Interview ",
      id: 4,
      interviewId: 4,
      // model: 3,
      model: 1, // ai model id
      description:
        "Efficient Comprehensive Assessment: Combining traditional elements with a resume-based evaluation, this interview efficiently assesses a candidate's background and alignment with the company's needs and culture.",
    },
    {
      title: "HR Interview",
      id: 5,
      interviewId: 5,
      // model: 3,
      model: 1, // ai model id
      description:
        "Efficient Initial Screening: An HR interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    },
    {
      title: "English Practice Bot",
      id: 6,
      interviewId: 6,
      model: 1,
      description:
        "English practice bot is a bot that helps you to practice your English speaking skills. It will ask you questions and you have to answer them. It will also give you feedback on your answers.",
    },
    {
      title: "Basic Mock Practice",
      id: 7, // interview id
      interviewId: 7,
      model: 3, // ai model id
      // model: 1, // ai model id
      description:
        "Efficient for Foundation Building: Basic mock practice efficiently [ Efficiency 90% ] establishes a foundational understanding, aiding in confidence-building and initial self-assessment.",
    },
    {
      title: "HR Interview ",
      id: 8,
      interviewId: 8,
      // model: 3,
      model: 1, // ai model id
      description:
        "Efficient Initial Screening: An HR interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    },
    {
      title: "Viva interview",
      id: 9,
      interviewId: 9,
      model: 1,
      description:
        "Viva Interview offers real-time practice sessions to hone your viva skills. Engage in interactive assessments, showcase your knowledge, and boost your confidence for the actual viva session",
    },
    {
      title: "Coding Interview",
      id: 10,
      interviewId: 10,
      model: 1,
      description:
        "A coding interview assesses programming skills and problem-solving through technical challenges.",
    },
  ],

  interviewsProList: [
    {
      interviewId: 1,
      title: "Basic Mock Practice",
      id: 1, // interview id
      model: 3, // ai model id
      description:
        "Efficient for Foundation Building: Basic mock practice efficiently [ Efficiency 60% ] establishes a foundational understanding, aiding in confidence-building and initial self-assessment.",
    },
    {
      title: "Resume Based Interview",
      id: 2,
      interviewId: 2,
      // model: 3,
      model: 3, // ai model id
      description:
        "Efficient Initial Screening: A resume interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    },
    {
      title: "Company Specific Interview",
      id: 3,
      interviewId: 3,
      // model: 3,
      model: 3, // ai model id
      description:
        "Effective Candidate Evaluation: The company interview efficiently evaluates candidates through various formats, offering a comprehensive assessment of skills and cultural fit for the organization.",
    },
    {
      title: "Company Interview with Resume",
      id: 4,
      interviewId: 4,
      // model: 3,
      model: 3, // ai model id
      description:
        "Efficient Comprehensive Assessment: Combining traditional elements with a resume-based evaluation, this interview efficiently assesses a candidate's background and alignment with the company's needs and culture.",
    },
    {
      title: "HR Interview",
      id: 5,
      interviewId: 5,
      // model: 3,
      model: 3, // ai model id
      description:
        "Efficient Initial Screening: An HR interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    },
    {
      title: "English Practice Bot",
      id: 6,
      interviewId: 6,
      model: 3,
      description:
        "English practice bot is a bot that helps you to practice your English speaking skills. It will ask you questions and you have to answer them. It will also give you feedback on your answers.",
    },
    {
      title: "Basic Mock Practice",
      id: 7, // interview id
      interviewId: 7,
      model: 3, // ai model id
      // model: 1, // ai model id
      description:
        "Efficient for Foundation Building: Basic mock practice efficiently [ Efficiency 90% ] establishes a foundational understanding, aiding in confidence-building and initial self-assessment.",
    },
    {
      title: "HR Interview with resume",
      id: 8,
      interviewId: 8,
      // model: 3,
      model: 3, // ai model id
      description:
        "Efficient Initial Screening: An HR interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    },
    {
      title: "Viva interview",
      id: 9,
      interviewId: 9,
      model: 3,
      description: "fdavffhbas fefahbcjheva sfcehvanf chjenba fdc",
    },
    {
      title: "Coding Interview",
      id: 10,
      interviewId: 10,
      model: 3,
      description:
        "A coding interview assesses programming skills and problem-solving through technical challenges.",
    },
    {
      title: "AI interview",
      id: 2,
      interviewId: 2,
      // model: 3,
      model: 3, // ai model id
      description:
        "Efficient Initial Screening: A resume interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    },
    {
      title: "Manual interview",
      id: 12,
      interviewId: 12,
      model: 3,
      description:
        "Efficient Initial Screening: A resume interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    },
    {
      title: "AI HR interview",
      id: 8,
      interviewId: 8,
      // model: 3,
      model: 3, // ai model id
      description:
        "Efficient Initial Screening: An HR interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    },
    {
      title: "Manual HR interview",
      id: 11,
      interviewId: 11,
      model: 3,
      description:
        "Efficient Initial Screening: A HR interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    },
  ],
  logoUrl:
    "https://user-images.githubusercontent.com/63062130/245455182-b5ebedd3-1204-4b73-8b6a-c3eb1be818a8.png",

  // publicStorgeLink: "https://reaidystorage.blob.core.windows.net/reaidypublic",
  publicStorgeLink: "https://reaidystorage.blob.core.windows.net/reaidypublic",
  defaultProfilePic:
    "https://t4.ftcdn.net/jpg/02/15/84/43/360_F_215844325_ttX9YiIIyeaR7Ne6EaLLjMAmy4GvPC69.jpg",

  azureSpeechKey: enableBackUpAzureSpeechKey
    ? backUpAzureSpeechKey
    : productionAzureSpeechKey,

  isMobileView: window.innerWidth <= 1000,

  showhackathon: true,
  showNewUi: true,

  loginWarningImage:
    "https://reaidystorage.blob.core.windows.net/spotmiespublic/undraw_secure_login_pdn4.png",

  unUsedFieldsInInterviewObj: [
    "createdAt",
    "description",
    "isInterviewCompleted",
    "isInvitation",
    "isResultPublished",
    "questions",
    "result",
    "resume",
    "_id",
  ], // fields that are not required in interview object

  // productionStorageData: [
  //   {
  //     tittle: "Ressume_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=p0SnVqsxx%2BY1xVbv5PSp8fEjQrJf%2Fh5z9QK7zc4fD1M%3D",
  //     sasUrl:
  //       "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=p0SnVqsxx%2BY1xVbv5PSp8fEjQrJf%2Fh5z9QK7zc4fD1M%3D",
  //     container: "resumes",
  //     expiryDate: "20-03-2025",
  //     accountName: "reaidystorage",
  //     actions: ["interview", "resume"],
  //   },
  //   // {
  //   //   tittle: "ScreenRecord_storage",
  //   //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
  //   //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
  //   //   container: "screen-recodings",
  //   //   expiryDate: "20-03-2025",
  //   //   accountName: "reaidystorage",
  //   //   actions: ["recording"]
  //   // },
  //   {
  //     tittle: "Recordings_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=3MDtdX8TwummdnPUkzPpHK2JjMqpHLoXWG3mfsPxPhQ%3D",
  //     sasUrl:
  //       "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=3MDtdX8TwummdnPUkzPpHK2JjMqpHLoXWG3mfsPxPhQ%3D",
  //     container: "recordings",
  //     expiryDate: "20-03-2025",
  //     accountName: "reaidystorage",
  //     actions: ["recording"],
  //   },
  //   {
  //     tittle: "User-media_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=tlqtEu1HVhOSRqIw%2FE0btBesuAxCma9WdSE1%2BvNOuZg%3D",
  //     sasUrl:
  //       "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=tlqtEu1HVhOSRqIw%2FE0btBesuAxCma9WdSE1%2BvNOuZg%3D",
  //     container: "user-media",
  //     expiryDate: "20-03-2025",
  //     accountName: "reaidystorage",
  //     actions: ["profile", "user"],
  //   },
  // ],

  // backUpStorageData: [
  //   {
  //     tittle: "Ressume_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-09-11T07:23:40Z&se=2025-09-11T15:23:40Z&sv=2022-11-02&sr=c&sig=upAZWwf%2Fdg7elR7BN8GWHnjp0%2BLpv1xpcwWjckbgXP8%3D",
  //     sasUrl:
  //       "https://reaidy.blob.core.windows.net/resumes?sp=racwdli&st=2024-09-11T07:23:40Z&se=2025-09-11T15:23:40Z&sv=2022-11-02&sr=c&sig=upAZWwf%2Fdg7elR7BN8GWHnjp0%2BLpv1xpcwWjckbgXP8%3D",
  //     container: "resumes",
  //     expiryDate: "11-09-2025",
  //     accountName: "reaidy",
  //     actions: ["interview", "resume"],
  //   },
  //   // {
  //   //   tittle: "ScreenRecord_storage",
  //   //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
  //   //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
  //   //   container: "screen-recodings",
  //   //   expiryDate: "11-09-2025",
  //   //   accountName: "reaidystorage",
  //   //   actions: ["recording"]
  //   // },
  //   {
  //     tittle: "Recordings_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-09-11T07:21:44Z&se=2025-09-11T15:21:44Z&sv=2022-11-02&sr=c&sig=6v6N%2BXkONdtC0vW%2BstvwlNGKIOzfZrOqGuYA1S58ULk%3D",
  //     sasUrl:
  //       "https://reaidy.blob.core.windows.net/recordings?sp=racwdli&st=2024-09-11T07:21:44Z&se=2025-09-11T15:21:44Z&sv=2022-11-02&sr=c&sig=6v6N%2BXkONdtC0vW%2BstvwlNGKIOzfZrOqGuYA1S58ULk%3D",
  //     container: "recordings",
  //     expiryDate: "11-09-2025",
  //     accountName: "reaidy",
  //     actions: ["recording"],
  //   },
  //   {
  //     tittle: "User-media_storage",
  //     sasToken:
  //       "sp=racwdli&st=2024-09-11T07:19:18Z&se=2025-09-09T15:19:18Z&sv=2022-11-02&sr=c&sig=a0oLX%2BTxEnbhGkTevFaqlZOWOCVFTC%2BA5g7gxXy%2BKbw%3D",
  //     sasUrl:
  //       "https://reaidy.blob.core.windows.net/user-media?sp=racwdli&st=2024-09-11T07:19:18Z&se=2025-09-09T15:19:18Z&sv=2022-11-02&sr=c&sig=a0oLX%2BTxEnbhGkTevFaqlZOWOCVFTC%2BA5g7gxXy%2BKbw%3D",
  //     container: "user-media",
  //     expiryDate: "11-09-2025",
  //     accountName: "reaidy",
  //     actions: ["profile", "user"],
  //   },
  // ],

  mails: {
    update_on_application: {
      subject: "Update on Your Application for [_Position_]",
      body: "Dear candidate,\n\nWe hope this message finds you well. Thank you for applying for the [_Position_] at [_Company_Name_]. We appreciate the time and effort you invested in sharing your profile with us.\n\nWe wanted to provide you with an update regarding your application:\n\nAt [_Company_Name_], we value the contributions and aspirations of all candidates. While the selection process is competitive, we are thrilled to consider talented individuals like you for opportunities.\n\nIf your application has been shortlisted, our recruitment team will contact you shortly with further details about the next steps in the hiring process.\n\nIf your profile was not selected this time, we encourage you to stay connected with us and apply for future opportunities that match your expertise and career goals.\n\nFor any questions or additional information, feel free to reach out to us at [_recruiter_email_] or call us at [_contact_number_].\n\nThank you once again for your interest in joining [_Company_Name_]. We wish you all the best in your professional journey.\n\nBest regards,\n[_Name_]\n[_your_Position_]\n[_Company_Name_]",
    },
    on_hold: {
      subject: "Update on Your Application for [_Position_]",
      body: "Dear candidate,\n\nThank you for applying for the [_Position_] at [_Company_Name_]. We appreciate the time and effort you invested in sharing your profile with us.\n\nWe wanted to inform you that your application is currently on hold. While we were impressed with your qualifications and experience, we are still in the process of evaluating all applications to ensure we make the best decision for this role.\n\nPlease be assured that your profile remains under consideration, and we will update you as soon as we have more information regarding the next steps.\n\nIn the meantime, if you have any questions or additional information you’d like to share with us, please feel free to reach out to us at [_recruiter_email_] or call us at [_contact_number_].\n\nThank you for your patience and understanding. We truly value your interest in joining [_Company_Name_] and will keep you informed about your application status.\n\nBest regards,\n[_Name_]\n[_your_Position_]\n[_Company_Name_]",
    },
    proxy: {
      subject:
        "Update on Your Application for [_Position_] at [_Company_Name_]",
      body: "Dear Candidate,\n\nThank you for your interest in the [_Position_] position at [_Company_Name_].\n\nWe are writing to inform you that during your online interview, our proxy detection system identified unethical interview activities that violate our assessment integrity policies.\n\n**Detected Proxy Activities:**\n[_Proxy_Reasons_]\n\nAs part of our commitment to maintaining a fair and transparent hiring process, we have a zero-tolerance policy for such practices. After careful review of the detected activities, we regret to inform you that we will not be moving forward with your application for this position at this time.\n\nWe appreciate the effort you put into your application. However, to ensure fairness for all candidates, we must maintain strict standards regarding assessment integrity.\n\nThank you for your understanding.\n\nBest regards,\n[_Name_]\n[_your_Position_]\n[_Company_Name_]",
    },
    incomplete_assessment: {
      subject: "Reminder: Complete Your Assessment for [_Position_]",
      body: "Dear Candidate,\n\nThank you for your interest in the [_Position_] at [_Company_Name_]. We noticed that you have started your application but have not yet completed the required assessment.\n\nTo move forward with your application, please follow the steps below to complete your assessment:\n\nNext Steps:\nGo to http://app.reaidy.io/\n\nNavigate to the Applicants section.\nSelect the Job Title you applied for.\nTake the Assessment.\n\nPlease make sure to complete the assessment by [_deadline_date_].\n\nIf you encounter any issues or have any questions regarding the assessment, feel free to reach out to us at [_recruiter_email_] or contact us at [_contact_number_].\n\nWe appreciate your interest in joining [_Company_Name_] and look forward to receiving your completed assessment.\n\nBest regards,\n[_Name_]\n[_your_Position_]\n[_Company_Name_]",
    },
    assessment_not_started: {
      subject: "Action Required: Start Your Assessment for [_Position_]",
      body: "Dear Candidate,\n\nThank you for applying for the [_Position_] at [_Company_Name_]. We noticed that you have not yet started the required assessment, which is an essential part of the application process.\n\nTo proceed with your application, please follow the steps below to begin your assessment:\n\nNext Steps:\nGo to http://app.reaidy.io/.\nNavigate to the Applicants section.\nSelect the Job Title you applied for.\nStart your Assessment.\n\nPlease make sure to begin the assessment by [_deadline_date_] to continue being considered for the position.\n\nIf you need any assistance or have questions, feel free to reach out to us at [_recruiter_email_] or contact us at [_contact_number_].\n\nWe appreciate your interest in joining [_Company_Name_] and look forward to seeing your completed assessment.\n\nBest regards,\n[_Name_]\n[_your_Position_]\n[_Company_Name_]",
    },
    assessment_completed: {
      subject: "Congratulations on Completing Your Assessment for [_Position_]",
      body: "Dear Candidate,\n\nThank you for completing the assessment for the [_Position_] at [_Company_Name_]. We appreciate the time and effort you put into the assessment, and we are excited to inform you that your profile is now under review.\n\nOur recruitment team will carefully evaluate your results, and we will be in touch with you soon regarding the next steps in the hiring process. This may include an interview or further discussions.\n\nIf you have any questions or would like to follow up, please don’t hesitate to reach out to us at [_recruiter_email_] or contact us at [_contact_number_].\n\nThank you once again for your interest in joining [_Company_Name_]. We look forward to progressing with your application.\n\nBest regards,\n[_Name_]\n[_your_Position_]\n[_Company_Name_]",
    },
    shortlisted: {
      subject: "Congratulations! You’ve Been Shortlisted for the [_Position_]",
      body: "Dear Candidate,\n\nWe are pleased to inform you that you have been shortlisted for the [_Position_] at [_Company_Name_]. After reviewing your application and assessment results, we are impressed by your qualifications and experience.\n\nWhat’s Next:\nOur recruitment team will reach out to you shortly with further details on the next steps. This may include a phone interview, an in-person interview, or additional assessments, depending on the role.\n\nIf you have any questions or need further information, please feel free to contact us at [_recruiter_email_] or call us at [_contact_number_].\n\nThank you once again for your interest in joining [_Company_Name_]. We are excited to move forward in the process and look forward to connecting with you soon.\n\nBest regards,\n[_Name_]\n[_your_Position_]\n[_Company_Name_]",
    },

    hired: {
      subject:
        "Congratulations! You've Been Hired for [_Position_] at [_Company_Name_]!",
      body: `Dear candidate,\n\nI hope this message finds you well. We are thrilled to inform you that your application for the [_Position_] position at [_Company_Name_] has been successful. We were highly impressed with your experience and qualifications, and we are excited to welcome you to our team.\n\nWhat’s Next?\nOur HR team will be reaching out to you shortly to discuss the next steps, including the onboarding process, your start date, and any other necessary details. Please keep an eye on your email for further instructions.\n\nAbout [_Company_Name_]:\nAt [_Company_Name_], we are passionate about [briefly describe what your company does, its mission, or values]. We believe that your skills and experience will be a valuable addition to our team, and we are excited to see the contributions you will make.\n\nContact Information:\nIf you have any questions in the meantime, please feel free to reach out to us at [_recruiter_email_] or call us at [_contact_number_]. We are here to help!\n\nThank you once again for your interest in joining [_Company_Name_]. We look forward to working with you and are excited about the future ahead.\n\nBest regards,\n[_Name_]\n[_your_Position_]\n[_Company_Name_]`,
    },

    rejected: {
      subject:
        "Outcome of Your Application for [_Position_] at [_Company_Name_]",
      body: "Dear Candidate,\n\nThank you for your interest in the [_Position_] at [_Company_Name_]. After careful consideration, we regret to inform you that we will not be moving forward with your application at this time.\n\nWe appreciate the effort you put into the application and assessment process. While we won’t be progressing with your candidacy for this role, we were impressed by your qualifications and encourage you to apply for future opportunities that may align with your skills and experience.\n\nThank you once again for considering a career with [_Company_Name_]. We wish you the best in your job search and future endeavors.\n\nBest regards,\n[_Name_]\n[_your_Position_]\n[_Company_Name_]",
    },
    resume_above_80: {
      subject:
        "Congratulations! Your Resume Has Scored Above 80% for [_Position_]",
      body: "Dear Candidate,\n\nWe are pleased to inform you that your resume has received a score of above 80% for the [_Position_] at [_Company_Name_]. Your qualifications and experience are highly impressive, and we are excited to move forward with your application.\n\nWhat’s Next:\nOur recruitment team will review your profile in more detail and will be in touch with you shortly regarding the next steps, which may include an interview or further assessments.\n\nIf you have any questions or would like to discuss your application further, please feel free to reach out to us at [_recruiter_email_] or call us at [_contact_number_].\n\nThank you for your interest in joining [_Company_Name_]. We look forward to the next steps and to learning more about how your skills can contribute to our team.\n\nBest regards,\n[_Name_]\n[_your_Position_]\n[_Company_Name_]",
    },
    resume_rejected: {
      subject:
        "Outcome of Your Application for [_Position_] at [_Company_Name_]",
      body: "Dear Candidate,\n\nThank you for your interest in the [_Position_] at [_Company_Name_]. After reviewing your resume, we regret to inform you that we will not be moving forward with your application at this time.\n\nWe appreciate the effort you put into applying and want to thank you for considering a career with us. While we are unable to proceed with your candidacy for this role, we encourage you to apply for future opportunities that may better match your qualifications and experience.\n\nThank you again for your interest in [_Company_Name_]. We wish you the best in your job search and future endeavors.\n\nBest regards,\n[_Name_]\n[_your_Position_]\n[_Company_Name_]",
    },
  },

  storageData: enableAzureBackupForStorage
    ? backUpStorageData
    : productionStorageData,

  viewCollegeReaidyStorageData: [
    {
      tittle: "Ressume_storage",
      sasToken:
        "sp=racwdli&st=2024-03-25T07:09:53Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=5d545w24dKK%2FG5Rpb7ups38SGNWZzubMz%2BE%2FO1GvxG8%3D",
      sasUrl:
        "https://viewcollegereaidy.blob.core.windows.net/resumes?sp=racwdli&st=2024-03-25T07:09:53Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=5d545w24dKK%2FG5Rpb7ups38SGNWZzubMz%2BE%2FO1GvxG8%3D",
      container: "resumes",
      expiryDate: "20-03-2025",
      accountName: "viewcollegereaidy",
      actions: ["interview", "resume"],
    },
    {
      tittle: "Recordings_storage",
      sasToken:
        "sp=racwdli&st=2024-03-25T07:12:31Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=L7pSUHeHVRVWTPGbLKHlpiwZvQF27OicYg%2BYXxlagAQ%3D",
      sasUrl:
        "https://viewcollegereaidy.blob.core.windows.net/recordings?sp=racwdli&st=2024-03-25T07:12:31Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=L7pSUHeHVRVWTPGbLKHlpiwZvQF27OicYg%2BYXxlagAQ%3D",
      container: "recordings",
      expiryDate: "20-03-2025",
      accountName: "viewcollegereaidy",
      actions: ["recording"],
    },
    {
      tittle: "User-media_storage",
      sasToken:
        "sp=racwdli&st=2024-03-25T07:15:06Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=g%2FTeNc3OgLheVlFSv16kZmM2CISRcv02WwqEgRvzyEw%3D",
      sasUrl:
        "https://viewcollegereaidy.blob.core.windows.net/user-media?sp=racwdli&st=2024-03-25T07:15:06Z&se=2025-03-20T18:29:00Z&sv=2022-11-02&sr=c&sig=g%2FTeNc3OgLheVlFSv16kZmM2CISRcv02WwqEgRvzyEw%3D",
      container: "user-media",
      expiryDate: "20-03-2025",
      accountName: "viewcollegereaidy",
      actions: ["profile", "user"],
    },
  ],
});
